import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { MENU_ROOT_STATE } from "@/types/NavigationState";
import { getHashFromLandingPage } from "@/containers/LandingPageHelper/LandingPageHelper";
import type { RootState } from "@/types/RootState";

interface SidebarLogoProps {
  logoPath?: string;
}

const SidebarLogo = ({ logoPath }: SidebarLogoProps) => {
  const history = useHistory();
  const loginInfo = useSelector((state: RootState) => state.user);

  return (
    <div className="sidebar-header">
      <div className="sidebar-logo">
        <a
          onClick={() => {
            // This login's own landing page, not a hardcoded Home path: a
            // partner without the legacy Home menu cannot open /tracked_assets
            // (STIC-15365), and getHashFromLandingPage already sends it to
            // /organization. Bare, like the pill's own tab — own level IS the
            // absence of `?org=`, and an id here would read as a slice for
            // anyone the url is shared with.
            history.push(getHashFromLandingPage(loginInfo), MENU_ROOT_STATE);
          }}
          href=" "
        >
          <img src={logoPath} alt={"Home"} />
        </a>
      </div>
    </div>
  );
};

export default SidebarLogo;
